import { Button, Card, Spinner } from '@meshhub/design-tokens/ui';
import { LogIn, Network } from 'lucide-react';
import React from 'react';
import { useAuth } from '../lib/auth.jsx';
import { S } from '../lib/strings.js';

/** Shown while unauthenticated. Every route falls back here. */
export function LoginScreen() {
  const { status, login, error } = useAuth();

  if (status === 'loading') {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-4">
        <Spinner />
        <p className="text-base text-text-muted">{S.auth.signingIn}</p>
      </div>
    );
  }

  return (
    <div className="flex h-screen items-center justify-center p-6">
      <Card className="flex w-overlay max-w-full flex-col items-center gap-5 text-center">
        <span className="flex items-center gap-2 text-xl font-bold">
          <Network size={22} className="text-primary" aria-hidden="true" />
          {S.app.name}
        </span>
        <p className="text-base text-text-muted">{S.auth.signInHint}</p>

        {error && (
          <p role="alert" className="text-base text-danger">
            {error}
          </p>
        )}

        <Button variant="primary" onClick={login} className="gap-2">
          <LogIn size={16} aria-hidden="true" />
          {S.auth.signInAction}
        </Button>
      </Card>
    </div>
  );
}
